interface IVolumeIconProps {
  muted: boolean
}

export const VolumeIcon = ({ muted }: IVolumeIconProps) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <g
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      {muted ? (
        <>
          <path d='M18.3327 18.3346L1.66602 1.66797' />
          <path d='M14.166 8.33203C14.6907 8.97095 14.9993 9.7532 14.9993 10.5983C14.9993 10.9683 14.9402 11.3262 14.8296 11.6654' />
          <path d='M16.666 6.66797C17.7083 7.69256 18.3327 8.9973 18.3327 10.418C18.3327 11.5983 17.9018 12.6986 17.1582 13.6246' />
          <path d='M11.666 11.6654C11.666 14.2864 11.666 16.2748 10.8943 16.6009C10.1228 16.9271 9.2146 16.0004 7.39827 14.1471C6.4576 13.1874 5.92102 12.9748 4.58268 12.9748C3.65593 12.9748 2.52226 13.0976 1.9469 12.2189C1.66602 11.79 1.66602 11.1929 1.66602 9.9987C1.66602 8.80445 1.66602 8.20735 1.9469 7.77841C2.52226 6.89979 3.65593 7.02261 4.58268 7.02261C5.50539 7.02261 6.1301 7.03094 6.63268 6.63203M11.666 7.91536C11.666 5.29436 11.6877 3.72258 10.916 3.39645C10.2736 3.12492 9.60963 3.72174 8.33268 4.9987' />
        </>
      ) : (
        <>
          <path d='M11.666 12.3433V7.65408C11.666 5.03308 11.666 3.72259 10.8949 3.39645C10.1238 3.07031 9.21631 3.99697 7.40128 5.8503C6.46134 6.81007 5.92505 7.0226 4.58771 7.0226C3.41816 7.0226 2.83338 7.0226 2.41331 7.30921C1.54131 7.90416 1.67312 9.06702 1.67312 9.9987C1.67312 10.9304 1.54131 12.0932 2.41331 12.6882C2.83338 12.9748 3.41816 12.9748 4.58771 12.9748C5.92506 12.9748 6.46134 13.1873 7.40128 14.1471C9.21631 16.0004 10.1238 16.9271 10.8949 16.6009C11.666 16.2748 11.666 14.9643 11.666 12.3433Z' />
          <path d='M14.166 7.5C14.6872 8.18306 14.9993 9.05287 14.9993 10C14.9993 10.9471 14.6872 11.8169 14.166 12.5' />
          <path d='M16.666 5.83203C17.7083 6.97047 18.3327 8.42014 18.3327 9.9987C18.3327 11.5773 17.7083 13.0269 16.666 14.1654' />
        </>
      )}
    </g>
  </svg>
)
